// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"335":"a6ec051b","688":"43e2c47e"}[chunkId] + ".chunk.css";
};